import { FaPlay } from "react-icons/fa";
import styled from "styled-components";

export const CarouselContainer = styled.div`
  overflow: visible;
  width: 100%;
  max-width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ScrollWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.CONSTANTS.XW * 3}px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: ${({ theme }) => theme.CONSTANTS.XW * 3}px;
  max-width: 100%;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Card = styled.div<{ $active: boolean }>`
  flex: 0 0 auto;
  width: ${({ $active }) => ($active ? "200px" : "100px")};
  height: 200px;
  border-radius: ${({ theme }) => theme.CONSTANTS.XR * 16}px;
  overflow: hidden;
  position: relative;
  scroll-snap-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: ${({ $active }) => ($active ? "scale(1.05)" : "scale(1)")};
  box-shadow: ${({ $active, theme }) =>
    $active ? `0 0 10px 4px ${theme.THEME.neonBlue}` : "none"};
  animation: ${({ $active }) => ($active ? "pulse 1.5s infinite" : "none")};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: ${({ theme }) => theme.CONSTANTS.XR * 16}px;
  }

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 0 12px 6px ${({ theme }) => theme.THEME.neonBlue};
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 8px 3px ${({ theme }) => theme.THEME.neonBlue};
    }
    50% {
      box-shadow: 0 0 12px 6px ${({ theme }) => theme.THEME.neonBlue};
    }
    100% {
      box-shadow: 0 0 8px 3px ${({ theme }) => theme.THEME.neonBlue};
    }
  }

  @media (min-width: 1025px) {
    width: ${({ $active }) => ($active ? "300px" : "200px")};
    height: 300px;
  }
`;

export const PlayIcon = styled(FaPlay)`
  position: absolute;
  font-size: 32px;
  color: rgba(255, 255, 255, 0.3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  transition: opacity 0.3s ease;
`;

export const ExpandedContent = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.72);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 12px;
  text-align: center;
  z-index: 3;

  p {
    color: ${({ theme }) => theme.THEME.white};
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 30}px;
    font-weight: 700;
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 1}px;
    font-family: "Audiowide", sans-serif;

    @media (min-width: 1025px) {
      font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
    }
  }

  .controls {
    display: flex;
    justify-content: center;
    gap: 12px;
    color: ${({ theme }) => theme.THEME.white};

    svg {
      cursor: pointer;
      font-size: 16px;
      transition: 0.3s;

      &:hover {
        color: ${({ theme }) => theme.THEME.neonBlue};
      }
    }
  }
`;
